'use client';

import { GoogleReCaptchaProvider as GRecapctchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';

export function GoogleReCaptchaProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { i18n } = useTranslation();

  return (
    <GRecapctchaProvider
      container={{
        // element: 'ep-starter__footer--recaptcha',
        parameters: {
          badge: 'bottomleft',
        },
      }}
      language={i18n.language}
      reCaptchaKey={process.env.NEXT_PUBLIC_SITE_KEY || ''}
      useEnterprise
    >
      {children}
    </GRecapctchaProvider>
  );
}
